var _rect, _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfileIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 12,
    fill: "#D5D6FE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.6569 37.3773C39.6569 40.9829 34.3612 42.6736 27.8284 42.6736C21.2957 42.6736 16 40.766 16 37.3773C16 30.8445 21.2957 25.5488 27.8284 25.5488C34.3612 25.5488 39.6569 30.8445 39.6569 37.3773Z",
    fill: "#3E5BD5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.6557 37.3791C39.6557 40.9847 34.3599 42.6755 27.8272 42.6755C22.9642 42.6755 18.7865 41.6184 16.9688 39.6801C19.0965 40.5409 21.9924 40.9962 25.1837 40.9962C31.7164 40.9962 37.0121 39.3056 37.0121 35.7C37.0121 32.0614 35.3693 28.8067 32.7849 26.6367C36.8412 28.5116 39.6557 32.6167 39.6557 37.3791Z",
    fill: "#1C359F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8275 28.9831C32.2411 28.9831 35.819 25.4051 35.819 20.9915C35.819 16.5779 32.2411 13 27.8275 13C23.4139 13 19.8359 16.5779 19.8359 20.9915C19.8359 25.4051 23.4139 28.9831 27.8275 28.9831Z",
    fill: "#3E5BD5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.822 20.9922C35.822 25.4058 32.2439 28.9839 27.8303 28.9839C24.043 28.9839 20.8707 26.3492 20.0469 22.8125C21.2523 25.2737 23.7819 26.9685 26.7072 26.9685C30.801 26.9685 34.1196 23.6499 34.1196 19.5562C34.1196 17.2752 33.0893 15.2348 31.4686 13.875C34.0532 15.1986 35.822 17.8888 35.822 20.9922Z",
    fill: "#1C359F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8825 18.2028C23.5813 19.5038 22.6895 20.7218 21.8424 19.8749C20.9952 19.0277 21.3633 17.2861 22.6646 15.9848C23.9658 14.6838 25.7073 14.3155 26.5544 15.1626C27.4017 16.0096 26.1837 16.9015 24.8825 18.2028Z",
    fill: "#6078E1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4176 32.3004C21.1164 33.6015 20.2247 34.8195 19.3775 33.9725C18.5304 33.1254 18.8985 31.3837 20.1997 30.0825C21.501 28.7814 23.2424 28.4131 24.0896 29.2603C24.9367 30.1073 23.7189 30.9992 22.4176 32.3004Z",
    fill: "#6078E1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIcon);
export default __webpack_public_path__ + "static/media/profile-icon.1c9a2152e6b0e580841e5fc3a71ffaa2.svg";
export { ForwardRef as ReactComponent };